export default __webpack_public_path__ + "static/form-editor-005cd3917ac487f57cf2e2ee682d8756.png";